module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs/icon.png?5cc53a437bee628a56eeeded3827ff2d";